module.exports = __webpack_public_path__ + "img/kefu2.ab84a8cf.jpg";